import { BaseAction } from "../../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IPassenger, IPassengerSelection } from "../../../../Orchestrator/Types/Index";
import { IPassengerChange } from "../../../../Orchestrator/Types/Interface/EventParams/PassengerAction";

class CheckPassengerDetailsCompletionAction extends BaseAction<void, IPassengerChange> {
    override async run(): Promise<void | null> {
        try {
            const { passengerData, totalPassengersCnt } = this.params!;
            const passengerTypes: IPassengerSelection[] = getRecoilStateValue("passengerTypesStateAtom") as IPassengerSelection[];
            //const passengerData = this.params!;
            let isComplete = false; // Default to false

            if (passengerData.length !== totalPassengersCnt) {
                isComplete = false;
            }

            if (passengerData && passengerData.length > 0 && passengerData.length == totalPassengersCnt) {

                // Directly perform the check on passenger details
                isComplete = passengerData.every((passenger) => {
                    // if (
                    //     !passenger?.detail?.firstName?.trim() ||
                    //     !passenger.detail.lastName?.trim()
                    // ) {
                    //     return false;
                    // }
                    const firstName = passenger?.detail?.firstName?.trim() || "";
                    const lastName = passenger?.detail?.lastName?.trim() || "";

                    // Check name validity: at least 2 characters
                    if (firstName.length < 2 || lastName.length < 2) {
                        return false;
                    }
                    // Dynamic DOB requirement based on passengerTypes minAge for key types
                    const seniorType = passengerTypes?.find((pt) => pt.id?.toLowerCase() === "seniorcitizens");
                    const childrenType = passengerTypes?.find((pt) => pt.id?.toLowerCase() === "children");
                    const infantsType = passengerTypes?.find((pt) => pt.id?.toLowerCase() === "infants");

                    const seniorMin = typeof seniorType?.minAge === "number" ? seniorType!.minAge : undefined;
                    const childrenMin = typeof childrenType?.minAge === "number" ? childrenType!.minAge : undefined;
                    const infantsMin = typeof infantsType?.minAge === "number" ? infantsType!.minAge : undefined;

                    const ageVal = passenger?.detail?.age;
                    if (typeof ageVal === "number") {
                        if (typeof seniorMin === "number" && ageVal === seniorMin && !passenger?.dateOfBirth) {
                            return false;
                        }
                        if (typeof childrenMin === "number" && ageVal === childrenMin && !passenger?.dateOfBirth) {
                            return false;
                        }
                        if (typeof infantsMin === "number" && ageVal === infantsMin && !passenger?.dateOfBirth) {
                            return false;
                        }
                    }
                    return true;
                });
            }

            // Update the atom state
            updateRecoilState<boolean>("areAllPassengerDetailsCompleteAtom", isComplete);

        } catch (error) {
            console.error("Error in CheckPassengerDetailsCompletionAction:", error);
            updateRecoilState<boolean>("areAllPassengerDetailsCompleteAtom", false);
        }
        return null;
    }
}

export const checkPassengerDetailsCompletionAction = new CheckPassengerDetailsCompletionAction(); 